"use client";

import { SDUIComponentRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUISectionStyleWrapper } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionStyleWrapper/SDUISectionStyleWrapper";
import { SDUISectionInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { Column } from "@faire/web/slate/Layout";
import React from "react";

export const SDUIColumnSectionRenderer = ({
  section,
  componentRenderers,
  sectionLoggingData,
  loadTimingRef,
  UPLTprops,
  shouldRenderBelowTheFold,
  onClickClientDismissHandler,
}: SDUISectionInstanceRendererProps) => {
  const columnSection = section.column_section;

  if (!columnSection) {
    return null;
  }

  const containSecondaryContent =
    section.column_section?.components.find(
      (component) => component.is_required_for_interactivity !== true
    ) !== undefined;

  return (
    <SDUISectionStyleWrapper sectionStyles={section.style}>
      <Column className="w-full">
        {columnSection.components.map((component) => {
          const isPrimaryContent =
            component.is_required_for_interactivity === true;

          if (!shouldRenderBelowTheFold && !isPrimaryContent) {
            return null;
          }

          return (
            <SDUIComponentRenderer
              key={component.id}
              component={component}
              componentRenderers={componentRenderers}
              sectionLoggingParams={sectionLoggingData}
              isPrimaryContent={isPrimaryContent}
              loadTimingRef={loadTimingRef}
              onClickClientDismissHandler={onClickClientDismissHandler}
            />
          );
        })}
        {!shouldRenderBelowTheFold && containSecondaryContent
          ? UPLTprops?.belowTheFoldLoadingSkeleton
          : null}
      </Column>
    </SDUISectionStyleWrapper>
  );
};
